import React, { useMemo } from 'react';
import { Checkbox, List, ListItem } from '@groupelacentrale/contact-storybook';
import { VehicleDescriptionItem } from 'types';
import {
  VehicleDescriptionFormViewSection,
  VehicleDescriptionFragmentProps,
} from './VehicleDescriptionFormViewSection';

export interface VehicleDescriptionFormViewSectionProps<T> {
  title: string;
  name: string;
  vehicleDescriptionList: T[];
  setVehicleDescriptionList: React.Dispatch<React.SetStateAction<T[]>>;
}

const NormalList: React.FC<VehicleDescriptionFragmentProps> = ({ name, checkedElements, handleCheck }) => {
  return (
    <List>
      {(checkedElements as VehicleDescriptionItem[]).map(vehicleDescription => (
        <ListItem key={'li' + vehicleDescription.label}>
          <Checkbox
            name={name}
            label={vehicleDescription.label}
            value={vehicleDescription.label}
            checked={vehicleDescription.selected}
            onChange={handleCheck}
          />
        </ListItem>
      ))}
    </List>
  );
};

export const VehicleDescriptionFormViewBasic: React.FC<VehicleDescriptionFormViewSectionProps<
  VehicleDescriptionItem
>> = ({ vehicleDescriptionList, ...props }) => {
  const [checkedElements, uncheckedElements] = useMemo(
    () =>
      vehicleDescriptionList.reduce<(VehicleDescriptionItem | string)[][]>(
        ([checked, unchecked], description) => {
          if (description.selected) checked.push(description);
          else unchecked.push(description.label);
          return [checked, unchecked];
        },
        [[], []],
      ),
    [vehicleDescriptionList],
  );

  return (
    <VehicleDescriptionFormViewSection
      {...props}
      vehicleDescriptionList={vehicleDescriptionList}
      checkedElements={checkedElements as VehicleDescriptionItem[]}
      uncheckedElements={uncheckedElements as string[]}
      uncheckedCounter={uncheckedElements.length}
      Fragment={NormalList}
    />
  );
};
